import { render, staticRenderFns } from "./PContextMenu.vue?vue&type=template&id=2a13e19c&"
import script from "./PContextMenu.vue?vue&type=script&lang=js&"
export * from "./PContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports